import { BasicUserInfo, Permission, User } from '@shared/models/user.models';
import { CheckLineReport } from "@shared/hooks/management-structure/CheckLineReport";

export function WithCanUserViewHolidayInfoPopup(currentUser?: User, user?: BasicUserInfo): boolean {
  const isLineReport = CheckLineReport(currentUser, user?.userId);
  const holidayBookingEnabled = currentUser?.companyEntity.enableHolidayBooking;

  if (!window.location.href.includes('/holidays')) {
    return false;
  }

  if (!holidayBookingEnabled) {
    return false;
  }

  if (currentUser?.role === Permission.CompanyAdmin) {
    return true;
  }

  if (currentUser?.role === Permission.TeamAdmin && currentUser.teamEntity !== null && currentUser.teamEntity.id === user?.teamId) {
    return true;
  }

  return isLineReport;
}
